<template>
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="32"
      height="32"
      rx="8"
      fill="url(#paint0_linear_77_120314)"
    />
    <path
      d="M22.9954 21.0815L23.7061 16.5656H19.2599V13.6363C19.2599 12.4005 19.8799 11.1952 21.8713 11.1952H23.894V7.35057C23.894 7.35057 22.0591 7.04544 20.3057 7.04544C16.6424 7.04544 14.2502 9.2088 14.2502 13.1237V16.5656H10.1797V21.0815H14.2502V32.5C15.2706 32.5 15.9979 32.5 16.7251 32.5C17.5768 32.5 18.5433 32.5 19.2706 32.5L19.2599 21.0815H22.9954Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_77_120314"
        x1="16"
        y1="0.5"
        x2="16"
        y2="32.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#17AAFD" />
        <stop offset="1" stop-color="#0164E0" />
      </linearGradient>
    </defs>
  </svg>
</template>
